// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2n-Ab","ranges":"BmiRanges_ranges__DPqP_"};